/**
 * OnlineStatus Component
 * Shows online/offline status with optional last seen
 */

import React from 'react';
import './OnlineStatus.css';

interface OnlineStatusProps {
  isOnline: boolean;
  showDot?: boolean;
  showText?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const OnlineStatus: React.FC<OnlineStatusProps> = ({
  isOnline,
  showDot = true,
  showText = true,
  size = 'md',
  className = '',
}) => {
  return (
    <div className={`online-status ${size} ${className}`}>
      {showDot && (
        <span className={`status-dot ${isOnline ? 'online' : 'offline'}`}></span>
      )}
      {showText && (
        <span className={`status-text ${isOnline ? 'online' : 'offline'}`}>
          {isOnline ? 'Online' : 'Offline'}
        </span>
      )}
    </div>
  );
};

export default OnlineStatus;
